
// --- Helper Functions ---
export function calculateKmProgress(startKm, dueKm, drivenKm) {
  const totalKm = dueKm - startKm;
  let coveredKm = drivenKm;

  // Clamp to valid range
  coveredKm = Math.max(0, Math.min(coveredKm, totalKm));

  return ((coveredKm / totalKm) * 100).toFixed(1);
}

export function calculateMonthProgress(startDateStr, dueDateStr, currentDateStr) {
  // Convert "Month YYYY" → Date
  const toDate = (str) => new Date(Date.parse("01 " + str));

  const start = toDate(startDateStr);
  const due = toDate(dueDateStr);
  const current = currentDateStr ? toDate(currentDateStr) : new Date();

  // Helper to get months between
  const monthsBetween = (from, to) => (to.getFullYear() - from.getFullYear()) * 12 + (to.getMonth() - from.getMonth());

  const totalMonths = monthsBetween(start, due);
  let progressMonths = monthsBetween(start, current);

  // Clamp within range
  progressMonths = Math.max(0, Math.min(progressMonths, totalMonths));

  return ((progressMonths / totalMonths) * 100).toFixed(1);
}


export function apiDateToDate(dateStr) {
  if (!dateStr) return null;
  return new Date(`${dateStr}T00:00:00`);
}
